import { useMutation, UseMutationOptions } from 'react-query';

type ResultData = { error: string } | { client_secret: string };

type MutationError = Error | Response | { error: string };

type Variables = {
  amount: number;
};

type MutationOptions = UseMutationOptions<ResultData, MutationError, Variables>;

const topUpMutation: MutationOptions = {
  mutationFn: async (fields) => {
    const response = await fetch('/api/v1/top_up/create_checkout_session', {
      body: JSON.stringify(fields),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw await response.json();
    }
  },
};

export const useTopUp = (options?: Omit<MutationOptions, 'mutationFn'>) => {
  return useMutation({
    ...options,
    ...topUpMutation,
  });
};
